import { render, staticRenderFns } from "./PillsIncompletePage.vue?vue&type=template&id=0802d004&"
import script from "./PillsIncompletePage.vue?vue&type=script&lang=js&"
export * from "./PillsIncompletePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports